module.exports = __webpack_public_path__ + "img/jk.98faba73.svg";